export const ErrorMessages = {
  registrationError: 'Error in registration. Please contact your provider.',
  assessmentNotFound: 'Assessment not found. Please contact your provider.',
  assessmentRequestError: 'Error in opening the assessment. Please contact your provider.',
  selfRegistrationNotConfigured: 'Campaign is not configured for self-registration. Please contact your provider.',
  registrationRequestError: 'Error in opening the registration page. Please contact your provider.',
  testletRequestError: 'Error in opening the game. Please contact your provider.',
};
